import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import CaseReviewDetails from "../components/CaseReviewDetails";
import CaseReviewNavbar from "../components/CaseReviewNavbar";
import FooterSection from "../components/FooterSection";


function CaseReview({ name }) {
  // Generate a unique patient ID when component loads
  const generatePatientId = () => `PAT-${Date.now()}`;

  const [id, setId] = useState(generatePatientId()); // Initialize with a generated ID
  const [patientname, setName] = useState("");
  const [age, setAge] = useState("");
  const [culturalBackground, setCulturalBackground] = useState("");
  const [positiveWords, setPositiveWords] = useState([]);
  const API_BASE_URL = process.env.NODE_ENV === "production"
  ? process.env.REACT_APP_PROD_API_BASE_URL
  : process.env.REACT_APP_DEV_API_BASE_URL;
  const navigate = useNavigate();
  const highlightPositiveWords = (text) => {
    if (!text) return text;
    return text.split(" ").map((word, index) => {
      const wordLowerCase = word.toLowerCase();
      const isPositive = positiveWords.includes(wordLowerCase);

      return isPositive ? (
        <span key={index} className="highlight">
          {word}{" "}
        </span>
      ) : (
        <span key={index}>{word} </span>
      );
    });
  };

  return (
    
      <div className="flex flex-col min-h-screen">
        <div className="flex-1 z-10">
        <CaseReviewNavbar name={name} />
        </div>
        <div className="relative isolate px-6 pb-4 lg:px-8">
          <div className="mx-auto">
            <div className="text-center">
              <div className="flex-grow container mx-auto py-8 flex flex-col items-center justify-center">
                {" "}
                <div className="w-full overflow-hidden">
                  {/* <div className="p-4 sm:p-8 space-y-6 sm:space-y-8"> */}
                    
                        <CaseReviewDetails
                          id={id}
                          setId={setId}
                          patientname={patientname}
                          setName={setName}
                          age={age}
                          setAge={setAge}
                          culturalBackground={culturalBackground}
                          setCulturalBackground={setCulturalBackground}
                        />
                  {/* </div> */}
                </div>
              </div>{" "}
            </div>
          </div>
        </div>
        
      </div>
  );
}

export default CaseReview;
